module.exports = __webpack_public_path__ + "c72d5a045ca0c066c40578ecc72a5cfc.pdf";